import { render, staticRenderFns } from "./TimeSlots.vue?vue&type=template&id=8935e2a4&scoped=true"
import script from "./TimeSlots.vue?vue&type=script&lang=js"
export * from "./TimeSlots.vue?vue&type=script&lang=js"
import style0 from "./TimeSlots.vue?vue&type=style&index=0&id=8935e2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8935e2a4",
  null
  
)

export default component.exports